import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { faRedo } from "@fortawesome/free-solid-svg-icons/faRedo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { CustomInput } from "components/Common/CustomInput";
import { EduIDButton } from "components/Common/EduIDButton";
import { useAppSelector } from "eduid-hooks";
import { Field as FinalField, Form as FinalForm } from "react-final-form";
function CaptchaForm({ handleCaptchaCompleted, disabled, handleCaptchaCancel }) {
    function submitCaptchaForm(values, form) {
        const errors = {};
        if (values.value) {
            handleCaptchaCompleted(values.value);
            form.reset();
        }
        else {
            errors.value = "required";
        }
        return errors;
    }
    return (_jsx(FinalForm, { onSubmit: submitCaptchaForm, render: (formProps) => {
            var _a;
            const _submitError = Boolean(formProps.submitError && !formProps.dirtySinceLastSubmit);
            const _disabled = Boolean(formProps.hasValidationErrors ||
                _submitError ||
                formProps.pristine ||
                disabled ||
                !((_a = formProps.values) === null || _a === void 0 ? void 0 : _a["value"]));
            return (_jsx("form", { id: "captcha-form", onSubmit: formProps.handleSubmit, children: _jsxs("fieldset", { children: [_jsx(FinalField, { component: CustomInput, componentClass: "input", autoFocus: true, type: "text", name: "value", autoComplete: "off", label: _jsx(FormattedMessage, { id: "captcha.label", description: "captcha input label", defaultMessage: "Enter the code from the image" }) }), _jsxs("div", { className: "buttons", children: [_jsx(EduIDButton, { onClick: handleCaptchaCancel, buttonstyle: "secondary", id: "cancel-captcha-button", children: _jsx(FormattedMessage, { id: "common.cancel", defaultMessage: "Cancel", description: "button cancel" }) }), _jsx(EduIDButton, { buttonstyle: "primary", id: "captcha-continue-button", type: "submit", disabled: _disabled, onClick: formProps.handleSubmit, children: _jsx(FormattedMessage, { id: "common.continue", defaultMessage: "Continue", description: "Captcha button" }) })] })] }) }));
        } }));
}
export function InternalCaptcha({ getCaptcha, handleCaptchaCancel, handleCaptchaCompleted }) {
    const [captchaResponse, setCaptchaResponse] = useState();
    const is_configured = useAppSelector((state) => state.config.is_configured);
    function getNewCaptcha() {
        getCaptcha().then((captcha) => {
            setCaptchaResponse({
                captcha_img: captcha === null || captcha === void 0 ? void 0 : captcha.captcha_img,
                captcha_audio: captcha === null || captcha === void 0 ? void 0 : captcha.captcha_audio,
            });
        });
    }
    useEffect(() => {
        let aborted = false; // flag to avoid updating unmounted components after this promise resolves
        if (is_configured && !captchaResponse) {
            getCaptcha().then((captchaResponse) => {
                if (!aborted && captchaResponse) {
                    setCaptchaResponse({
                        captcha_img: captchaResponse.captcha_img,
                        captcha_audio: captchaResponse.captcha_audio,
                    });
                }
            });
        }
        // create a cleanup function that will allow the async code above to realise it shouldn't
        // try to update state on an unmounted react component
        return () => {
            aborted = true;
        };
    }, [captchaResponse, is_configured, getCaptcha]);
    return (_jsxs(_Fragment, { children: [_jsxs("figure", { className: "captcha-responsive", children: [_jsx("img", { alt: "captcha", className: "captcha-image", src: captchaResponse === null || captchaResponse === void 0 ? void 0 : captchaResponse.captcha_img }), _jsx("audio", { controls: true, className: "captcha-audio", src: captchaResponse === null || captchaResponse === void 0 ? void 0 : captchaResponse.captcha_audio }), _jsxs(EduIDButton, { buttonstyle: "link normal-case sm icon refresh", "aria-label": "refresh-captcha", disabled: !(captchaResponse === null || captchaResponse === void 0 ? void 0 : captchaResponse.captcha_img), onClick: getNewCaptcha, children: [_jsx(FontAwesomeIcon, { icon: faRedo }), _jsx("span", { children: _jsx(FormattedMessage, { id: "captcha.img", defaultMessage: "Generate a new captcha image", description: "captcha img change" }) })] })] }), _jsx(CaptchaForm, { handleCaptchaCancel: handleCaptchaCancel, handleCaptchaCompleted: handleCaptchaCompleted, getCaptcha: getCaptcha })] }));
}
